import NavigationLogin from "../../../../src/pages/components/navigationbar/components/navigationLogin";
import NavigationAvatar from "../../../../src/pages/components/navigationbar/components/navigationAvatar";
import NavigationSearch from "../../../../src/pages/components/navigationbar/components/navigationSearch";
import NavigationMenu from "../../../../src/pages/components/navigationbar/components/navigationMenu";
import * as React from 'react';
export default {
  NavigationLogin,
  NavigationAvatar,
  NavigationSearch,
  NavigationMenu,
  React
};